import { TextField } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import { callAxios, formatError } from 'components/utils/FormatData';
import { genKey, setStorage } from 'components/utils/Storage';
import { URL_API } from 'constants/settings';
import * as moment from 'moment';
import 'moment/locale/fr';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router';
import MyButton from '../../components/form/MyButton';

const SelectMotifAcquittement = (props) => {
  const [motifs, setMotifs] = useState([]);
  const [selectedMotif, setSelectedMotifs] = useState(null);
  const alert = useAlert();
  const history = useHistory();

  useEffect(() => {
    if (props.open) {
      fetchListMotifs();
    }
  }, [props.open]);
  useEffect(() => {
    if (props.wsStatus !== null) {
      fetchListMotifs();
    }
  }, [props.wsStatus]);

  const fetchListMotifs = () => {

    callAxios(props.wsStatus, "param_list_motifs", { method: 'get', url: URL_API + '/motifs' }, null, alert)
      .then((res) => {
        setMotifs(res);
        setStorage(genKey("param_list_motifs"), res);
      });

  }
  const closeModal = (reason) => {
    if (reason !== 'backdropClick') {
      setSelectedMotifs(null);
      setMotifs([]);
      props.setOpen(false);
    }
  };
  const handleAcknowledgeAlarms = () => {
    if (selectedMotif) {

      props.setBtnAcknowledgeAlarmsIsLoading(true);

      if (selectedMotif.avecCreationOT) {
        axios({ method: 'get', url: `${URL_API}/equipements/${props.entity.id}` })
        .then((res) => {
          history.push(`/equipement/ot/creation/${props.entity.id}`, { comment: generateCommentForOt(props.entity.alarmesActives), motif: selectedMotif, equipment: res.data  });
        })
        .catch((err) => {
          alert.error(`Erreur lors de la récupération des informations de l'équipement [${props.entity.id}]`);
        });
      } else {
        axios({ method: 'put', url: `${URL_API}/equipements/${props.entity.id}/alarmes/acquitter?motifId=${selectedMotif.id}` })
          .then(function () {
            alert.success(`Les alarmes de l'équipement [${props.entity.id}] ont bien été acquittées`);
            props.setBtnAcknowledgeAlarmsIsLoading(false);
            props.setNeedUpdate(true);
            closeModal();
          })
          .catch(function (err) {
            formatError(alert, err);
            props.setBtnAcknowledgeAlarmsIsLoading(false);
          });
      }

    } else {
      alert.error(`Vous devez sélectionner un motif d'acquittement des alarmes avant de continuer`);
    }
  };
  const generateCommentForOt = (alarmes) => {
    let comment = '';

    for (const alarme of alarmes) {
      if (!alarme.acquitEtat) {
        comment += `${comment !== '' ? '\n' : ''} ${moment(alarme.dateDeb).format('DD/MM/YYYY HH:mm')} ${alarme.equipementToponyme ? ' - ' + alarme.equipementToponyme : ''} - ${alarme.typeAlarmeCode} - ${alarme.typeAlarmeLibelle}`;
      }
    }

    return comment;
  };

  return (
    <Modal open={props.open} onClose={(event, reason) => closeModal(reason)} style={{ display: 'flex', width: '90vw', margin: 'auto' }} disableEscapeKeyDown={true}>
      <div className={isMobile ? 'select-motif-acquittement-mobile' : 'select-motif-acquittement'}>
        <h3 style={{ textTransform: 'uppercase', color: '#27313c', fontSize: isMobile ? '3.5vw' : '1vw' }}>Sélectionner le motif d'acquittement</h3>

        <Autocomplete
          options={motifs}
          value={selectedMotif}
          onChange={(e, v) => setSelectedMotifs(v)}
          getOptionLabel={(option) => option.libelle || ''}
          getOptionSelected={(option, value) => option.id === value.id}
          style={{ width: '75%', margin: 'auto' }}
          renderInput={(params) => <TextField {...params} label={`Motif d'acquittement`} />}
          disabled={!props.wsStatus}
        />

        <div className="row">
          {
            !props.btnAcknowledgeAlarmsIsLoading && <MyButton
              className="classic-button btn-default color-fond-bleu"
              type="button"
              labelImportant="Annuler"
              href="#"
              onClick={() => closeModal()}
            />
          }

          {
            props.wsStatus &&
            <MyButton
              className="classic-button btn-default color-fond-vert"
              type="button"
              labelImportant="Valider"
              href="#"
              onClick={() => handleAcknowledgeAlarms()}
              isLoading={props.btnAcknowledgeAlarmsIsLoading}
            />
          }
          {
            !props.wsStatus &&
            <MyButton
              className="classic-button btn-default color-fond-gris"
              type="button"
              labelImportant="Valider"
              href="#"
              styleCss={{ cursor: 'default' }}
            />
          }

        </div>
      </div>
    </Modal>
  );
};

export default SelectMotifAcquittement;